import React from "react"
import {graphql} from "gatsby"
import Layout from "../components/layout"
import {Seo} from "../seo"
import {ShortIntro} from "../components/short-intro";
import StrapiImage from "../components/strapi-image";
import Markdown from "react-markdown";
import StrapiMarkdownImage from "../components/strapi-markdown-image";
import CallToAction from "../components/call-to-action";
import ContactCallToAction from "../components/contact-call-to-action/contact-call-to-action";
import StrapiMarkdown from "../components/strapi-markdown";

const SkillsPage = ({data, pageContext, location}) => {

    const skillData = data.allStrapiSkill.nodes[0];

    return (
        <>
            <ShortIntro/>

            <main>

                <div className={"container-xl mb-6"}>
                    <div className={"row"}>
                        <div className={"col-12 section"}>
                            <article>
                                <div className={"d-flex flex-row align-items-center mt-1 pb-2"}>
                                    <StrapiImage file={skillData.logo} />

                                    <div className={"ms-3 w-100"}>
                                        <h1 className={"dashed"}>
                                            <span className={"pr-4"}>
                                                {skillData.name}
                                            </span>
                                        </h1>
                                        <p className={"subtitle"}>
                                            {skillData.short_description}
                                        </p>
                                    </div>
                                </div>
                                <StrapiMarkdown
                                    medias={skillData.description.medias}
                                    markdown={skillData.description.data.description} />
                            </article>
                        </div>
                    </div>

                </div>

                <CallToAction />
                <ContactCallToAction />

            </main>

        </>
    )
}

export const Head = ({pageContext, data}) => <Seo
    pageContext={pageContext}
    seoComponent={data.allStrapiSkill.nodes[0].seo} />

export default SkillsPage

export const pageQuery = graphql`
    query SkillBySlug($language: String!, $originalPath: String!) {
        allStrapiSkill(
            filter: {locale: {eq: $language}, url: {url_de: {eq: $originalPath}}}
        ) {
            nodes {
                name
                short_description
                seo {
                    metaTitle
                    metaDescription
                }
                description {
                    medias {
                        alternativeText
                        url
                        localFile {
                            childImageSharp {
                                gatsbyImageData
                            }
                        }
                    }
                    data {
                        description
                    }
                }
                logo {
                    localFile {
                        svg {
                            content
                        }
                        publicURL
                        childImageSharp {
                            gatsbyImageData(width: 100, placeholder: NONE)
                        }
                    }
                    alternativeText
                    mime
                }
            }
        }
        
    }
`
